'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheckCircle, FeatherChevronRight, FeatherClock, FeatherCompass, FeatherFileText, FeatherRefreshCw, FeatherUploadCloud, FeatherXCircle } from '@subframe/core';
import type { ReactNode } from 'react';
import { Button } from '@/shared/components/ui';
import type { UseNotificacaoSelfReturn } from '../hooks';
import { WizardHeader } from './WizardHeader';
export type PagamentoScreenVm = Pick<UseNotificacaoSelfReturn, 'pagamentoStatus' | 'pagamentoErro' | 'pollingExpirado' | 'confirmandoRevisao' | 'stepperSteps' | 'reabrirCheckout' | 'tentarPagamentoNovamente' | 'verificarPagamentoAgora' | 'sairPara' | 'goTo'>;
interface PagamentoScreenProps {
  vm: PagamentoScreenVm;
}
interface OpcaoInicio {
  icon: ReactNode;
  titulo: string;
  descricao: string;
  rota: string;
}
const OPCOES_INICIO: OpcaoInicio[] = [{
  icon: <FeatherFileText className="text-brand-600" />,
  titulo: 'Enviar notificação individual',
  descricao: 'Envie notificações extrajudiciais individualmente, uma por vez.',
  rota: '/notificacoes/criar/individual'
}, {
  icon: <FeatherUploadCloud className="text-brand-600" />,
  titulo: 'Enviar notificação em lote',
  descricao: 'Envie várias notificações extrajudiciais de uma vez importando planilha.',
  rota: '/notificacoes/criar/em-massa'
}, {
  icon: <FeatherCompass className="text-brand-600" />,
  titulo: 'Explorar a plataforma',
  descricao: 'Conheça o dashboard e descubra outros produtos da Arbitralis.',
  rota: '/'
}];
const Aguardando = t0 => {
  const $ = _c(5);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-brand-50 flex h-16 w-16 items-center justify-center rounded-full"><FeatherClock className="text-brand-600 h-7 w-7" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex max-w-[480px] flex-col items-center gap-2 text-center"><h1 className="text-heading-dark text-xl font-semibold sm:text-[26px]">Só um instante, estamos confirmando seu pagamento</h1><p className="text-label-muted text-sm leading-relaxed">Você foi redirecionado para finalizar o pagamento. Assim que confirmarmos, você terá acesso à plataforma para começar a notificar.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex max-w-[440px] items-center gap-3 rounded-[12px] bg-neutral-50 px-4.5 py-3.5"><FeatherRefreshCw className="h-4.5 w-4.5 flex-none animate-spin text-neutral-500" /><div><div className="text-heading-dark text-[13px] font-semibold">Pagamento em processamento</div><div className="text-xs text-neutral-500">Processamento seguro via Asaas. A confirmação pode levar alguns instantes.</div></div></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== vm.reabrirCheckout) {
    t4 = <div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 py-12">{t1}{t2}{t3}<button type="button" onClick={vm.reabrirCheckout} className="text-brand-600 text-[13px] font-semibold underline">Não fui redirecionado</button></div>;
    $[3] = vm.reabrirCheckout;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
const Erro = t0 => {
  const $ = _c(16);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-error-50 flex h-16 w-16 items-center justify-center rounded-full"><FeatherXCircle className="text-error-600 h-7 w-7" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h1 className="text-heading-dark text-xl font-semibold sm:text-[26px]">Seu pagamento não foi aprovado</h1>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = vm.pagamentoErro ?? "O pagamento pode ter sido recusado ou cancelado. Tente novamente selecionando outra forma de pagamento.";
  let t4;
  if ($[2] !== t3) {
    t4 = <div className="flex max-w-[480px] flex-col items-center gap-2 text-center">{t2}<p className="text-label-muted text-sm leading-relaxed">{t3}</p></div>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== vm) {
    t5 = <Button variant="neutral-secondary" size="medium" onClick={() => vm.goTo("revisao")}>Voltar para a revisão</Button>;
    $[4] = vm;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherRefreshCw />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== vm.confirmandoRevisao || $[8] !== vm.tentarPagamentoNovamente) {
    t7 = <Button size="medium" iconRight={t6} loading={vm.confirmandoRevisao} disabled={vm.confirmandoRevisao} onClick={vm.tentarPagamentoNovamente}>Tentar novamente</Button>;
    $[7] = vm.confirmandoRevisao;
    $[8] = vm.tentarPagamentoNovamente;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <div className="flex items-center gap-3">{t5}{t7}</div>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t8) {
    t9 = <div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 py-12">{t1}{t4}{t8}</div>;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
const AguardandoExpirado = t0 => {
  const $ = _c(10);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-warning-50 flex h-16 w-16 items-center justify-center rounded-full"><FeatherClock className="text-warning-700 h-7 w-7" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex max-w-[480px] flex-col items-center gap-2 text-center"><h1 className="text-heading-dark text-xl font-semibold sm:text-[26px]">Ainda não conseguimos confirmar seu pagamento</h1><p className="text-label-muted text-sm leading-relaxed">A confirmação está demorando mais que o normal. Se você já pagou, verifique de novo em instantes — assim que o pagamento compensar, sua conta é liberada.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== vm.reabrirCheckout) {
    t3 = <Button variant="neutral-secondary" size="medium" onClick={vm.reabrirCheckout}>Reabrir pagamento</Button>;
    $[2] = vm.reabrirCheckout;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FeatherRefreshCw />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== vm.verificarPagamentoAgora) {
    t5 = <Button size="medium" iconRight={t4} onClick={vm.verificarPagamentoAgora}>Verificar novamente</Button>;
    $[5] = vm.verificarPagamentoAgora;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 py-12">{t1}{t2}<div className="flex items-center gap-3">{t3}{t5}</div></div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
const Sucesso = t0 => {
  const $ = _c(6);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-success-50 flex h-16 w-16 items-center justify-center rounded-full"><FeatherCheckCircle className="text-success-700 h-7 w-7" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex max-w-[480px] flex-col items-center gap-2 text-center"><h1 className="text-heading-dark text-xl font-semibold sm:text-[26px]">Tudo pronto! Sua conta está ativa 🎉</h1><p className="text-label-muted text-sm leading-relaxed">Pagamento confirmado. Por onde você quer começar?</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== vm) {
    t3 = OPCOES_INICIO.map(opcao => <button key={opcao.titulo} type="button" onClick={() => vm.sairPara(opcao.rota)} className="flex items-center gap-3.5 rounded-[12px] border border-solid border-neutral-200 px-4 py-3.5 text-left transition-colors hover:bg-neutral-50"><div className="bg-brand-50 flex h-9 w-9 flex-none items-center justify-center rounded-[8px]">{opcao.icon}</div><div className="flex-1"><div className="text-heading-dark text-sm font-semibold">{opcao.titulo}</div><div className="text-xs text-neutral-500">{opcao.descricao}</div></div><FeatherChevronRight className="text-neutral-400" /></button>);
    $[2] = vm;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 py-12">{t1}{t2}<div className="flex w-full max-w-[460px] flex-col gap-2.5">{t3}</div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export const PagamentoScreen = t0 => {
  const $ = _c(7);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] !== vm.stepperSteps) {
    t1 = <WizardHeader steps={vm.stepperSteps} />;
    $[0] = vm.stepperSteps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== vm) {
    t2 = vm.pagamentoStatus === "erro" ? <Erro vm={vm} /> : vm.pagamentoStatus === "sucesso" ? <Sucesso vm={vm} /> : vm.pollingExpirado ? <AguardandoExpirado vm={vm} /> : <Aguardando vm={vm} />;
    $[2] = vm;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};